<template>
  <router-view/>
</template>

<style lang="scss">
@import "@/assets/scss/reset.scss";
@import "@/assets/scss/vars.scss";

body {
  background-color: $white;

  @include mobile {
    min-height: 100vh;
  }
}

.container {
  max-width: 1300px;
  width: 100%;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  min-height: calc(100vh - 120px);

  @include mobile {
    min-height: 100vh;
    justify-content: unset;
  }

  * {
    width: 100%;
  }
}

.light-blue-bg {
  background-color: $light-blue;
}

.button {
  padding: 30px 0;
  text-align: center;
  max-width: 320px;
  width: 100%;
  background-color: $pink;
  color: $white;
  text-decoration: none;
  transition: $transition-time;
  transform-origin: center;
  cursor: pointer;

  &:hover {
    color: $white;
    transform: scale(1.05);
    background-color: lighten($pink, 3%)
  }

  &:active {
    transform: scale(0.9);
    background-color: darken($pink, 9%)
  }

  @include mobile {
    padding: 15px 30px;
    width: fit-content;
  }
}
</style>
